import Model from './model';

export default class PersonaType extends Model {
  static NAME = 'persona_type';
  static COLLECTION_NAME = "persona_types";
  static URL = '/api/v2/persona_types';
}